import { render } from "./FacturaPrint.vue?vue&type=template&id=62311338&scoped=true"
import script from "./FacturaPrint.vue?vue&type=script&lang=ts"
export * from "./FacturaPrint.vue?vue&type=script&lang=ts"

import "./FacturaPrint.vue?vue&type=style&index=0&id=62311338&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62311338"

export default script